import PocketBase from "pocketbase";

import { BuildConfig } from "@uic/adapters/confenv";

export const pb = new PocketBase(BuildConfig.WSC_ADDRESS);
